import { Component } from 'react';
import { AnalyticsConstants, trackEvent } from '../utilities/analyticsUtilities';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error, errorInfo) {
    trackEvent('Javascript Error', {
      error,
      errorInfo,
      category: AnalyticsConstants.PERFORMANCE_CATEGORY,
    })
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;